import { observable } from "mobx";
import { InputNode } from ".";
import { ElementType } from "../enums";
import { TemplateNodeVisitor } from "./ops/nodeVisitor";

export class TextBoxNode extends InputNode<string> {

    @observable public invalidPhoneMessage?: string;

    @observable public invalidZipCodeMessage?: string;

    public constructor() {
        super();
        this.elementType = ElementType.Textbox;
    }

    public accept(visitor: TemplateNodeVisitor) {
        visitor.visitTextBoxNode(this);
    }
}

export class DateNode extends InputNode<Date> {

    @observable public pastDateMessage?: string;

    @observable public futureDateMessage?: string;

    @observable public invalidDateMessage?: string;
    
    public constructor() {
        super();
        this.elementType = ElementType.Date;
    }

    public validateSubmission(shouldShortCircuit: boolean): boolean {
        if (!super.validateSubmission(shouldShortCircuit)) {
            return false;
        }

        const now: Date = new Date(Date.now());
        const input = this.input !== undefined ? new Date(this.input) : undefined;

        this.errors = [];
        if (input === undefined && this.invalidDateMessage !== undefined) {
            this.errors = [this.invalidDateMessage];
            return false;
        }

        if ((this.futureDateMessage === undefined && this.pastDateMessage === undefined) && input === undefined) {
            return true;
        }

        if (this.futureDateMessage !== undefined && (input === undefined || input <= now)) {
            this.errors = [this.futureDateMessage];
            return false;
        }

        if (this.pastDateMessage !== undefined && (input === undefined || input >= now)) {
            this.errors = [this.pastDateMessage];
            return false;
        }

        return true;
    }

    public accept(visitor: TemplateNodeVisitor) {
        visitor.visitDateNode(this);
    }
}

export class CheckboxNode extends InputNode<boolean> {
    public constructor() {
        super();
        this.elementType = ElementType.Checkbox;
    }

    public accept(visitor: TemplateNodeVisitor) {
        visitor.visitCheckboxNode(this);
    }
}
